import React from "react";
import { tenantDisplayName } from "../utils/tenantProfile";

function MailboxActions({ mailbox, onEdit, onSendEmail, onViewProfile }) {
  return (
    <div className="admin-row-actions">
      <button className="admin-button admin-button-secondary" type="button" onClick={() => onViewProfile(mailbox)}>
        View Profile
      </button>
      <button className="admin-button admin-button-primary" type="button" onClick={() => onSendEmail(mailbox)}>
        Send Mail
      </button>
      <button className="admin-button admin-button-secondary" type="button" onClick={() => onEdit(mailbox)}>
        Edit
      </button>
    </div>
  );
}

function occupancyColorClass(mailbox, showOccupancyColors) {
  if (!showOccupancyColors) return "";
  return mailbox.tenant ? "admin-mailbox-occupied" : "admin-mailbox-available";
}

export default function MailboxTable({
  mailboxes,
  viewMode = "list",
  showOccupancyColors = false,
  onEdit,
  onSendEmail,
  onViewProfile,
}) {
  if (!mailboxes.length) return <p className="admin-empty-state">No mailboxes found.</p>;

  if (viewMode === "grid") {
    return (
      <div className="admin-mailbox-grid">
        {mailboxes.map((mailbox) => (
          <article
            className={`admin-mailbox-card ${occupancyColorClass(mailbox, showOccupancyColors)}`.trim()}
            key={mailbox.id}
          >
            <div>
              <p>Mailbox</p>
              <h3>#{mailbox.number}</h3>
              <span>{mailbox.tenant ? tenantDisplayName(mailbox.tenant) : "No assigned tenant"}</span>
            </div>
            <MailboxActions
              mailbox={mailbox}
              onEdit={onEdit}
              onSendEmail={onSendEmail}
              onViewProfile={onViewProfile}
            />
          </article>
        ))}
      </div>
    );
  }

  return (
    <div className="admin-table-wrap">
      <table className="admin-table admin-mailbox-table">
        <thead>
          <tr>
            <th>Mailbox Number</th>
            <th>Assigned Tenant</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {mailboxes.map((mailbox) => (
            <tr className={occupancyColorClass(mailbox, showOccupancyColors)} key={mailbox.id}>
              <td>#{mailbox.number}</td>
              <td>{mailbox.tenant
                ? tenantDisplayName(mailbox.tenant)
                : <span className="admin-muted-value">No assigned tenant</span>}</td>
              <td>
                <MailboxActions
                  mailbox={mailbox}
                  onEdit={onEdit}
                  onSendEmail={onSendEmail}
                  onViewProfile={onViewProfile}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
